module.exports = __webpack_public_path__ + "static/media/silver.01212dd3.png";